"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _indi_indiUnifiedLtLogo = _interopRequireDefault(require("./logos/indi_indi-unified-lt-logo-1.svg"));
var _indi_indiUnifiedLtLogo2 = _interopRequireDefault(require("./logos/indi_indi-unified-lt-logo-2.svg"));
var _indi_indiUnifiedLtLogo3 = _interopRequireDefault(require("./logos/indi_indi-unified-lt-logo-3.svg"));
var _indi_indiUnifiedLtLogo4 = _interopRequireDefault(require("./logos/indi_indi-unified-lt-logo-4.svg"));
var _indi_indiUnifiedDkLogo = _interopRequireDefault(require("./logos/indi_indi-unified-dk-logo-1.svg"));
var _indi_indiUnifiedDkLogo2 = _interopRequireDefault(require("./logos/indi_indi-unified-dk-logo-2.svg"));
var _indi_indiUnifiedDkLogo3 = _interopRequireDefault(require("./logos/indi_indi-unified-dk-logo-3.svg"));
var _indi_indiUnifiedDkLogo4 = _interopRequireDefault(require("./logos/indi_indi-unified-dk-logo-4.svg"));
var _indi_indiCreativeLtLogo = _interopRequireDefault(require("./logos/indi_indi-creative-lt-logo-1.svg"));
var _indi_indiCreativeLtLogo2 = _interopRequireDefault(require("./logos/indi_indi-creative-lt-logo-2.svg"));
var _indi_indiCreativeLtLogo3 = _interopRequireDefault(require("./logos/indi_indi-creative-lt-logo-3.svg"));
var _indi_indiCreativeLtLogo4 = _interopRequireDefault(require("./logos/indi_indi-creative-lt-logo-4.svg"));
var _indi_indiCreativeDkLogo = _interopRequireDefault(require("./logos/indi_indi-creative-dk-logo-1.svg"));
var _indi_indiCreativeDkLogo2 = _interopRequireDefault(require("./logos/indi_indi-creative-dk-logo-2.svg"));
var _indi_indiCreativeDkLogo3 = _interopRequireDefault(require("./logos/indi_indi-creative-dk-logo-3.svg"));
var _indi_indiCreativeDkLogo4 = _interopRequireDefault(require("./logos/indi_indi-creative-dk-logo-4.svg"));
var _indi_indiSuccessLtLogo = _interopRequireDefault(require("./logos/indi_indi-success-lt-logo-1.svg"));
var _indi_indiSuccessLtLogo2 = _interopRequireDefault(require("./logos/indi_indi-success-lt-logo-2.svg"));
var _indi_indiSuccessLtLogo3 = _interopRequireDefault(require("./logos/indi_indi-success-lt-logo-3.svg"));
var _indi_indiSuccessLtLogo4 = _interopRequireDefault(require("./logos/indi_indi-success-lt-logo-4.svg"));
var _indi_indiSuccessDkLogo = _interopRequireDefault(require("./logos/indi_indi-success-dk-logo-1.svg"));
var _indi_indiSuccessDkLogo2 = _interopRequireDefault(require("./logos/indi_indi-success-dk-logo-2.svg"));
var _indi_indiSuccessDkLogo3 = _interopRequireDefault(require("./logos/indi_indi-success-dk-logo-3.svg"));
var _indi_indiSuccessDkLogo4 = _interopRequireDefault(require("./logos/indi_indi-success-dk-logo-4.svg"));
var _indi_indiTalentLtLogo = _interopRequireDefault(require("./logos/indi_indi-talent-lt-logo-1.svg"));
var _indi_indiTalentLtLogo2 = _interopRequireDefault(require("./logos/indi_indi-talent-lt-logo-2.svg"));
var _indi_indiTalentLtLogo3 = _interopRequireDefault(require("./logos/indi_indi-talent-lt-logo-3.svg"));
var _indi_indiTalentLtLogo4 = _interopRequireDefault(require("./logos/indi_indi-talent-lt-logo-4.svg"));
var _indi_indiTalentDkLogo = _interopRequireDefault(require("./logos/indi_indi-talent-dk-logo-1.svg"));
var _indi_indiTalentDkLogo2 = _interopRequireDefault(require("./logos/indi_indi-talent-dk-logo-2.svg"));
var _indi_indiTalentDkLogo3 = _interopRequireDefault(require("./logos/indi_indi-talent-dk-logo-3.svg"));
var _indi_indiTalentDkLogo4 = _interopRequireDefault(require("./logos/indi_indi-talent-dk-logo-4.svg"));
var _indi_indiInnovateLtLogo = _interopRequireDefault(require("./logos/indi_indi-innovate-lt-logo-1.svg"));
var _indi_indiInnovateLtLogo2 = _interopRequireDefault(require("./logos/indi_indi-innovate-lt-logo-2.svg"));
var _indi_indiInnovateLtLogo3 = _interopRequireDefault(require("./logos/indi_indi-innovate-lt-logo-3.svg"));
var _indi_indiInnovateLtLogo4 = _interopRequireDefault(require("./logos/indi_indi-innovate-lt-logo-4.svg"));
var _indi_indiInnovateDkLogo = _interopRequireDefault(require("./logos/indi_indi-innovate-dk-logo-1.svg"));
var _indi_indiInnovateDkLogo2 = _interopRequireDefault(require("./logos/indi_indi-innovate-dk-logo-2.svg"));
var _indi_indiInnovateDkLogo3 = _interopRequireDefault(require("./logos/indi_indi-innovate-dk-logo-3.svg"));
var _indi_indiInnovateDkLogo4 = _interopRequireDefault(require("./logos/indi_indi-innovate-dk-logo-4.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* Unified/Global Logos */

/* Creative Logos */

/* Success Logos */

/* Talent Logos */

/* Innovate Logos */

const Logos = {
  unified: {
    light: {
      variations: {
        v1: _indi_indiUnifiedLtLogo.default,
        v2: _indi_indiUnifiedLtLogo2.default,
        v3: _indi_indiUnifiedLtLogo3.default,
        v4: _indi_indiUnifiedLtLogo4.default
      }
    },
    dark: {
      variations: {
        v1: _indi_indiUnifiedDkLogo.default,
        v2: _indi_indiUnifiedDkLogo2.default,
        v3: _indi_indiUnifiedDkLogo3.default,
        v4: _indi_indiUnifiedDkLogo4.default
      }
    }
  },
  creative: {
    light: {
      variations: {
        v1: _indi_indiCreativeLtLogo.default,
        v2: _indi_indiCreativeLtLogo2.default,
        v3: _indi_indiCreativeLtLogo3.default,
        v4: _indi_indiCreativeLtLogo4.default
      }
    },
    dark: {
      variations: {
        v1: _indi_indiCreativeDkLogo.default,
        v2: _indi_indiCreativeDkLogo2.default,
        v3: _indi_indiCreativeDkLogo3.default,
        v4: _indi_indiCreativeDkLogo4.default
      }
    }
  },
  success: {
    light: {
      variations: {
        v1: _indi_indiSuccessLtLogo.default,
        v2: _indi_indiSuccessLtLogo2.default,
        v3: _indi_indiSuccessLtLogo3.default,
        v4: _indi_indiSuccessLtLogo4.default
      }
    },
    dark: {
      variations: {
        v1: _indi_indiSuccessDkLogo.default,
        v2: _indi_indiSuccessDkLogo2.default,
        v3: _indi_indiSuccessDkLogo3.default,
        v4: _indi_indiSuccessDkLogo4.default
      }
    }
  },
  talent: {
    light: {
      variations: {
        v1: _indi_indiTalentLtLogo.default,
        v2: _indi_indiTalentLtLogo2.default,
        v3: _indi_indiTalentLtLogo3.default,
        v4: _indi_indiTalentLtLogo4.default
      }
    },
    dark: {
      variations: {
        v1: _indi_indiTalentDkLogo.default,
        v2: _indi_indiTalentDkLogo2.default,
        v3: _indi_indiTalentDkLogo3.default,
        v4: _indi_indiTalentDkLogo4.default
      }
    }
  },
  innovate: {
    light: {
      variations: {
        v1: _indi_indiInnovateLtLogo.default,
        v2: _indi_indiInnovateLtLogo2.default,
        v3: _indi_indiInnovateLtLogo3.default,
        v4: _indi_indiInnovateLtLogo4.default
      }
    },
    dark: {
      variations: {
        v1: _indi_indiInnovateDkLogo.default,
        v2: _indi_indiInnovateDkLogo2.default,
        v3: _indi_indiInnovateDkLogo3.default,
        v4: _indi_indiInnovateDkLogo4.default
      }
    }
  }
};
var _default = exports.default = Logos;